import { SpaceSettingsPage } from "../settings/SpaceSettingsPage";

/**
 * `spaces/:spaceId/edit/space` (the gear): the one settings page (board `Ark-Settings`) from its first section. Kept under the old name
 * so the routing module needs no change; route `edit/*` to `SpaceSettingsPage` directly once the old sub-nav is gone.
 */
export function EditSpacePage() {
    return <SpaceSettingsPage />;
}
